<template lang="pug">
#modal-selecionar-cars-cpf-cnpj
    el-dialog.modal-selecionar-cars-cpf-cnpj-content(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='960px'
    )
        span(slot='title')
            h3
                b {{ $t('mensagens.relatorioRastreabilidade.cadastro.selecioneCarDesejaAdicionar') }}

        .el-collapse-item__container
            el-table(
                ref='tabelaModalSelecionarCarsCpfOuCnpjRef',
                :data='dadosPaginado',
                style='width: 100%'
            )
                el-table-column(width='50')
                    template(slot-scope='scope')
                        el-radio(v-model='dadoSelecionado', :label='scope.row') &nbsp

                el-table-column(label='CAR', width='435')
                    template(slot-scope='scope') {{ scope.row.codigo || scope.row.codigoCAR }}

                el-table-column(
                    :label='$t("mensagens.relatorioRastreabilidade.cadastro.origem")',
                    sortable,
                    prop='origem'
                )
                    template(slot-scope='scope') {{ scope.row.origem }}

                el-table-column(
                    :label='$t("mensagens.relatorioRastreabilidade.cadastro.municipioUf")',
                    prop='municipioUf'
                )
                    template(slot-scope='scope') {{ scope.row.municipioUf }}

        .c-pagination
            el-pagination(
                background,
                :page-size='pageCount',
                :pager-count='pageCount',
                :current-page.sync='paginaAtual',
                layout='prev, pager, next',
                :total='dados.length',
                @current-change='mudarPagina'
            )

        .informar-car-manualmente-car
            el-radio(v-model='dadoSelecionado', label='Informar manualmente') {{ $t('mensagens.relatorioRastreabilidade.cadastro.informarManualmente') }}

        footer.my-3(slot='footer')
            el-button(@click='fecharModal')
                | {{ $t('mensagens.comuns.voltar') }}
            div(v-if='!dadoSelecionado')
                el-tooltip(
                    effect='dark',
                    :content='$t("mensagens.relatorioRastreabilidade.cadastro.selecioneUmCarAntesDeConfirmar")',
                    placement='top'
                )
                    el-button(
                        type='primary',
                        @click='retornarDadosSelecionado'
                    )
                        | {{ $t('mensagens.comuns.confirmar') }}
            div(v-else)
                el-button(type='primary', @click='retornarDadosSelecionado')
                    | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
export default {
    name: 'ModalSelecionarCarsCpfCnpj',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        cpfCnpj: {
            type: String,
            required: false
        },
        dados: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            dadoSelecionado: null,
            paginaAtual: 1,
            pageCount: 5
        };
    },

    watch: {
        show: function () {
            if (!this.show) return;
            this.dadoSelecionado = null;
        }
    },

    computed: {
        dadosPaginado() {
            const inicio = (this.paginaAtual - 1) * this.pageCount;
            const fim = inicio + this.pageCount;

            return this.dados.slice(inicio, fim);
        }
    },

    methods: {
        retornarDadosSelecionado() {
            if (!this.dadoSelecionado) {
                return;
            }
            this.$emit(
                'retornarDadosSelecionados',
                this.dadoSelecionado.codigo || this.dadoSelecionado.codigoCAR
            );
        },

        mudarPagina(currentPage) {
            this.paginaAtual = currentPage;
        },

        fecharModal() {
            try {
                this.$messageBox
                    .confirm(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.alertaDadosNaoSeraoSalvos'
                        ),
                        this.$t('mensagens.comuns.aviso'),
                        {
                            confirmButtonText: this.$t('mensagens.comuns.sim'),
                            cancelButtonText: this.$t(
                                'mensagens.relatorioRastreabilidade.cadastro.permanecer'
                            ),
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.dadoSelecionado = null;
                        this.$emit('voltar');
                    })
                    .catch(() => {});
            } catch (erro) {}
        }
    }
};
</script>

<style lang="scss">
#modal-selecionar-cars-cpf-cnpj {
    footer {
        display: flex;
        justify-content: space-between;
    }
    .c-pagination {
        text-align: center;
        margin-top: 30px;
    }
    label {
        margin: 0 !important;
    }

    .informar-car-manualmente-car {
        display: flex;
        margin-top: 24px;
        gap: 5px;
        align-items: center;
        flex-wrap: wrap;
        background-color: #e7e7e7;
        border-radius: 5px;
        padding: 8px 8px;
        min-height: 6px;
    }
}
.modal-selecionar-cars-cpf-cnpj-content {
    .el-dialog__header {
        padding: 20px;
        padding-bottom: 10px;
        background: var(--primary);
        color: var(--white);
        padding-bottom: 12px;
        padding-top: 12px;
    }
    .el-dialog__headerbtn {
        top: 10px;
    }
    .el-dialog__headerbtn:hover .el-icon-close {
        color: #ffffff;
    }
    .modal-analise-elegibilidade--header {
        display: flex;
        align-items: center;
    }
}
</style>
